import React from "react";
import { FaMagnifyingGlass, FaFileLines, FaCode, FaCircleCheck, FaRocket } from "react-icons/fa6";
import { Container, H3_SIZE } from "../home/ui";
import WebSectionHead from "./WebSectionHead";

const steps = [
  { icon: FaMagnifyingGlass, title: "Discover", text: "We understand your business, goals, and requirements.", num: "bg-[#6D7BF7]", tone: "text-[#1E6BFF]" },
  { icon: FaFileLines, title: "Plan & Design", text: "We create strategy, wireframes, and modern designs.", num: "bg-[#6D7BF7]", tone: "text-[#4F46E5]" },
  { icon: FaCode, title: "Develop", text: "We build responsive, functional, and high-performance websites.", num: "bg-[#6D7BF7]", tone: "text-[#1E6BFF]" },
  { icon: FaCircleCheck, title: "Test & Refine", text: "We ensure quality, security, and compatibility across devices.", num: "bg-[#22B573]", tone: "text-[#1E6BFF]" },
  { icon: FaRocket, title: "Launch & Support", text: "We deploy your website and provide ongoing support.", num: "bg-[#8B5CF6]", tone: "text-[#7C3AED]" },
];

const WebProcess = () => (
  <section className="bg-white py-[64px] lg:py-[38px]">
    <Container>
      <WebSectionHead
        pill="Our Process"
        title="From Idea to a"
        highlight="Successful Website."
        subtitle="We follow a clear and collaborative process to deliver high-quality websites."
      />

      <div className="m-swipe mt-[44px] grid gap-[32px] sm:grid-cols-2 lg:grid-cols-5 lg:gap-[24px]">
        {steps.map((s, i) => (
          <div key={s.title} className="relative">
            {/* connector line to the next step (desktop) */}
            {i < steps.length - 1 && (
              <span className="absolute left-[96px] right-[-12px] top-[38px] hidden h-[2px] rounded-full bg-gradient-to-r from-[#C9D7FF] to-[#E3E9FF] lg:block" />
            )}
            <div className="relative inline-flex">
              <span className="inline-flex h-[76px] w-[76px] items-center justify-center rounded-full bg-gradient-to-b from-[#F1F5FF] to-[#E6EDFF] shadow-[0_10px_24px_-14px_rgba(40,60,140,0.4)]">
                <span className={`text-[26px] ${s.tone}`}>
                  <s.icon />
                </span>
              </span>
              <span
                className={`absolute -left-[10px] -top-[8px] inline-flex h-[24px] min-w-[24px] items-center justify-center rounded-full px-[5px] text-[11px] font-semibold text-white ring-2 ring-white ${s.num}`}
              >
                {String(i + 1).padStart(2, "0")}
              </span>
            </div>
            <h3 className={`mt-[20px] font-semibold text-ink ${H3_SIZE}`}>{s.title}</h3>
            <p className="mt-[8px] max-w-[220px] text-[14.5px] leading-[1.6] text-slate-500">{s.text}</p>
          </div>
        ))}
      </div>
    </Container>
  </section>
);

export default WebProcess;
